<header class="header customer_header header_bottom_shadow header_fix">
  <div class="header_main">
    <nav class="navbar navbar-expand-lg">
      <div class="container-fluid cstm-cntnr">
        <div class="logo_container1 header-logo-container">
          <ng-container *ngIf="this.token">
            <a routerLink="/student/dashboard" class="logos_head">
              <img src="assets/img/logo/osehub-logo.svg" class="" alt="HubbleHox" />
            </a>          
          </ng-container>
          <!-- <a href="https://mesta.net.in/MESTAOlympiadExam" class="mestaPrnt" target="_blank" *ngIf="!this.token" 
            onclick="gtag('event','MESTA_Logo_Click', {'app_name': 'mesta'})">
            <img src="assets/img/logo/mesta-logo-sv.svg" alt="MESTA Logo" />
          </a>
          <a href="https://mesta.net.in/MESTAOlympiadExam" class="mestaPrnt" target="_blank" *ngIf="this.token && this.userDetails.type != 'school'" onclick="gtag('event','MESTA_Logo_Click', {'app_name': 'mesta'})">
            <img src="  assets/img/logo/mesta-logo-sv.svg" alt="MESTA Logo" />
          </a>

          <a href="https://mesta.net.in/MESTAOlympiadExam" class="mestaPrnt" target="_blank" *ngIf="this.token && this.userDetails.type == 'school'" onclick="gtag('event','MESTA_Logo_Click', {'app_name': 'mesta'})">
            <img src="assets/img/logo/mesta-logo-sv.svg" alt="MESTA Logo" />
          </a> -->
        </div>
          <ul *ngIf="!this.token"
            class="standard_dropdown main_nav_dropdown d-flex justify-content-end align-items-center d-lg-none">
            <li>
              <!-- <a [routerLink]="currentRoute == '/auth/login' ? '/auth/teacher-registration' : '/auth/login'" class="btn btn_theme_outline d-flex align-items-center gap-2 login-btn">
                <span>
                  {{currentRoute == '/auth/login' ? 'Register' : 'Login'}}
                </span>
                <span class="d-none d-md-block">
                  / Register
                </span>
              </a> -->

              <!-- BUTTON - 1 (HELP BUTTON) -->
              <button [matMenuTriggerFor]="helpMenu" #createPlanmenuTrigger="matMenuTrigger" (mouseenter)="targetMenuTrigger = createPlanmenuTrigger;
                            mouseEnter(createPlanmenuTrigger)" (mouseleave)="mouseLeave(createPlanmenuTrigger)"
                class="btn btn-help rounded-pill me-4">
                Support
                <img class="img-fluid" src="assets/img/question-mark-circle.svg" alt="icon">
              </button>
              <!-- HELP POPUP -->
              <mat-menu #helpMenu="matMenu" [hasBackdrop]="false" [overlapTrigger]="false">
                <div (mouseenter)="mouseEnter(targetMenuTrigger)" (mouseleave)="mouseLeave(targetMenuTrigger)"
                  class="popup-content px-3 py-2">
                  <p class="fw-bold">Need Assistance?</p>
                  <hr>
                  <div class="d-flex align-items-center">
                    <img src="assets/img/phone-call.png" alt="Phone" class="me-2">
                    <a href="tel:+918422887258">+91 {{AppConfig.contacts.contact1.contact}}</a>
                  </div>
                  <hr>
                  <div class="d-flex align-items-center mt-2">
                    <img src="assets/img/mail.png" alt="Email" class="me-2">
                    <a href="mailto:contact@iited.com" class="text-decoration-underline">{{AppConfig.emails.email1}}</a>
                  </div>
                </div>
              </mat-menu>
            </li>
          </ul>

          <div *ngIf="this.token && this.userDetails?.type != 'parent'" class="position-relative d-lg-none d-block">
          <!-- BUTTON - 1 (HELP BUTTON) -->
          <button [matMenuTriggerFor]="helpMenu" #createPlanmenuTrigger="matMenuTrigger" (mouseenter)="targetMenuTrigger = createPlanmenuTrigger;
                              mouseEnter(createPlanmenuTrigger)" (mouseleave)="mouseLeave(createPlanmenuTrigger)"
            class="btn-help-responsive border border-1 shadow-sm me-3">
            <img class="img-fluid" src="assets/img/question-mark-circle.svg" alt="icon">
          </button>
          <!-- HELP POPUP -->
          <mat-menu #helpMenu="matMenu" [hasBackdrop]="false" [overlapTrigger]="false">
            <div (mouseenter)="mouseEnter(targetMenuTrigger)" (mouseleave)="mouseLeave(targetMenuTrigger)"
              class="popup-content px-3 py-2">
              <p class="fw-bold">Need Assistance?</p>
              <hr>
              <div class="d-flex align-items-center">
                <img src="assets/img/phone-call.png" alt="Phone" class="me-2">
                <a href="tel:+918422887258">+91 {{AppConfig.contacts.contact1.contact}}</a>
              </div>
              <hr>
              <div class="d-flex align-items-center mt-2">
                <img src="assets/img/mail.png" alt="Email" class="me-2">
                <a href="mailto:contact@iited.com" class="text-decoration-underline">{{AppConfig.emails.email1}}</a>
              </div>
            </div>
          </mat-menu>

          <!-- My Cart Button  -->
          <!-- <button *ngIf="userDetails?.type != 'institute'" (click)="addToCart()" class="btn-cart-responsive border border-1 rounded-circle position-relative shadow-sm mx-3" type="button">
            <img src="assets/img/shopping-cart.svg" alt="icon">
            Badge
            <span class="position-absolute top-10 start-80 translate-middle badge rounded-circle bg-primary" style="background-color: #2D5EAB !important;"> 
              {{ addToCartCount }}
            </span>
          </button> -->

          <!-- OLD -->
          <!-- <button *ngIf="this.token" class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button> -->
          <!-- NEW -->
            <button (click)="toggleDropdown()" class="mobile-user-btn shadow-sm" type="button">
              <i class="fa fa-user" style="color: #2A65C0;" aria-hidden="true"></i>
              <img src="assets/img/chevron-down.png" alt="icon">
            </button>

            <div class="custom-dropdown" *ngIf="isDropdownOpen">

              <!-- <button (click)="onMyProfile()" class="custom-menu-button profile-button">
                <div class="d-flex align-items-center">
                  <img class="me-2 icon" src="assets/img/edit-profile-icon.svg" alt="logo">
                  <span class="label">My Profile</span>
                </div>
              </button> -->

              <!-- <button (click)="onPurchaseHistory()" class="custom-menu-button purchase-button">
                <div class="d-flex align-items-center">
                  <img class="me-2 icon" src="assets/img/purchase-history-logo.svg" alt="logo">
                  <span class="label">{{userDetails?.type != 'institute' ? 'Purchase' : 'Payment'}} History</span>
                </div>
              </button> -->
            
              <button (click)="logout()" class="custom-menu-button logout-button">
                <div class="d-flex align-items-center">
                  <i class="fa fa-sign-out me-2 icon"></i>
                  <span class="label">Logout</span>
                </div>
              </button>
            </div>
          </div>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0"></ul>
          <div class="d-flex align-items-center justify-content-end justify_class">  
          <ul class="navbar-nav me-auto mb-2 mb-lg-0"></ul>        
            <ul *ngIf="!this.token"
              class="standard_dropdown main_nav_dropdown d-flex justify-content-end align-items-center">
              <li>

                <!-- BUTTON - 1 (HELP BUTTON) -->
                <button [matMenuTriggerFor]="helpMenu" #createPlanmenuTrigger="matMenuTrigger" (mouseenter)="targetMenuTrigger = createPlanmenuTrigger;
                                 mouseEnter(createPlanmenuTrigger)" (mouseleave)="mouseLeave(createPlanmenuTrigger)"
                  class="btn btn-help rounded-pill me-4">
                  Support
                  <img class="img-fluid" src="assets/img/question-mark-circle.svg" alt="icon">
                </button>
                <!-- HELP POPUP -->
                <mat-menu #helpMenu="matMenu" [hasBackdrop]="false" [overlapTrigger]="false">
                  <div (mouseenter)="mouseEnter(targetMenuTrigger)" (mouseleave)="mouseLeave(targetMenuTrigger)"
                    class="popup-content px-3 py-2">
                    <p class="fw-bold">Need Assistance?</p>
                    <hr>
                    <div class="d-flex align-items-center">
                      <img src="assets/img/phone-call.png" alt="Phone" class="me-2">
                      <a href="tel:+918422887258">+91 {{AppConfig.contacts.contact1.contact}}</a>
                    </div>
                    <hr>
                    <div class="d-flex align-items-center mt-2">
                      <img src="assets/img/mail.png" alt="Email" class="me-2">
                      <a href="mailto:contact@iited.com" class="text-decoration-underline">{{AppConfig.emails.email1}}</a>
                    </div>
                  </div>
                </mat-menu>

                <!-- <a [routerLink]="currentRoute == '/auth/login' ? '/auth/teacher-registration' : '/auth/login'" class="btn btn_theme_outline d-flex align-items-center gap-2 login-btn">
                  <span>
                    Login
                  </span>
                  <span class="d-none d-md-block">
                    / Register
                  </span>
                </a> -->
                
              </li>
            </ul>
            <ul *ngIf="this.token"
              class="standard_dropdown main_nav_dropdown d-flex justify-content-end align-items-center">
              <li>
                <!-------Student My account------>
                <div class="d-flex align-items-center" *ngIf="this.userDetails?.type != 'institute' && this.userDetails?.type != 'parent'">

                  <!-- <button class="btn btn_blue  animated_btn" *ngIf="shouldShowButton()"
                    (click)="RegistrationRequired()"><span>My Exam Dashboard</span></button> -->

                  <!-- OLD -->
                  <!-- <a routerLink="/student-exam-payment" *ngIf="userData?.student?.paymentStatus != 'success'">
                    <div class="d-flex align-items-center border_pro animated_btn">
                      <p class="my_account_text school_hdr_btn exam_hdr_btn">Register For HHSQ 2024-25</p>
                    </div>
                  </a> -->
                  <!-- NEW -->
                  <!-- <a (click)="openDialog()" style="cursor: pointer;" *ngIf="userData?.student?.paymentStatus != 'success'">
                    <div  class="d-flex align-items-center">
                      <p class="my_account_text school_hdr_btn disabled-exam_hdr_btn">Register For HHSQ 2024-25</p>
                    </div>
                  </a> -->
                  
                  <!-- <a routerLink="/exam-managment" *ngIf="userData?.student?.paymentStatus == 'success'">
                    <div class="d-flex align-items-center border_pro">
                      <p class="my_account_text btn_theme">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-grid-3x3-gap-fill me-1 mb-1" viewBox="0 0 16 16">
                          <path d="M1 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zM1 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zM1 12a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1z"/>
                        </svg>
                        Exam Dashboard
                      </p>
                    </div>
                  </a> -->
                  <!-- <a routerLink="/user/my-profile">
                    <div class="d-flex align-items-center border_pro student_profile_btn">
                      ALREADY COMMENTED <img
                                 [src]="this.userData.student.image?this.userData.student.image :  assets/img/my_profile.png" alt=""
 
                       class="my_profile_img"
                       alt=""
                     />


                      <p class="my_account_text school_hdr_btn">
                        <i class="fa fa-user me-1" aria-hidden="true"></i>
                        My Profile
                      </p>
                      <img *ngIf="this.userData?.student?.image" [src]=" this.userData.student.image " alt=""
                        onerror="src='assets/img/my_profile.png'" class="my_profile_img" alt="" />
                      <img ALREADY COMMENTED *ngIf="!this.userData?.student?.image"
                                 [src]="assets/img/my_profile.png" class="my_account_img" alt=""/>

                    </div>
                    ALREADY COMMENTED <button class="btn btn_theme text-truncate">My Account</button>
                  </a> -->

                  <!-- BUTTON - 1 (HELP BUTTON) -->
                  <button [matMenuTriggerFor]="helpMenu" #createPlanmenuTrigger="matMenuTrigger" (mouseenter)="targetMenuTrigger = createPlanmenuTrigger;
                                    mouseEnter(createPlanmenuTrigger)" (mouseleave)="mouseLeave(createPlanmenuTrigger)"
                    class="btn btn-help rounded-pill me-2">
                    Support
                    <img class="img-fluid" src="assets/img/question-mark-circle.svg" alt="icon">
                    
                  </button>
                  <!-- HELP POPUP -->
                  <mat-menu #helpMenu="matMenu" [hasBackdrop]="false" [overlapTrigger]="false">
                    <div (mouseenter)="mouseEnter(targetMenuTrigger)"
                    (mouseleave)="mouseLeave(targetMenuTrigger)" class="popup-content px-3 py-2">
                      <p class="fw-bold">Need Assistance?</p>
                      <hr>
                      <div class="d-flex align-items-center">
                        <img src="assets/img/phone-call.png" alt="Phone" class="me-2"> 
                        <a href="tel:+918422887258">+91 {{AppConfig.contacts.contact1.contact}}</a>
                      </div>
                      <hr>
                      <div class="d-flex align-items-center mt-2">
                        <img src="assets/img/mail.png" alt="Email" class="me-2">
                        <a href="mailto:contact@iited.com" class="text-decoration-underline">{{AppConfig.emails.email1}}</a>
                      </div>
                    </div>
                  </mat-menu>

                  <!-- <button (click)="toggleDropdown()" class="btn-user border border-1 rounded-pill me-2" type="button">
                    <span class="px-2 text-dark font-family-montserrat">
                      IIEP Rank:
                    </span>
                    <img src="assets/img/ranking.svg" alt="icon">
                  </button> -->
                  <!-- My Cart Button  -->
                  <!-- <button (click)="addToCart()" class="btn-cart border border-1 rounded-pill me-2 position-relative" type="button">
                    <span class="px-2 text-dark font-family-montserrat">
                      My Cart
                    </span>
                  
                    <img src="assets/img/shopping-cart.svg" alt="icon">
                  
                    Badge
                    <span class="position-absolute top-10 start-80 translate-middle badge rounded-circle bg-primary" style="background-color: #2D5EAB !important;">
                      {{ addToCartCount }}
                    </span>
                  </button> -->
                  
                  <!-- BUTTON - 2 (User Profile) -->
                  <div class="position-relative">
                    <button (click)="toggleDropdown()" class="btn-user d-flex align-items-center border border-1 rounded-pill px-3 py-2" type="button" style="min-width: 150px;">
                      
                      <!-- User Icon -->
                      <i class="fa fa-user me-2" style="color: #2A65C0; font-size: 1.2rem;" aria-hidden="true"></i>
                  
                      <!-- Text (Hello + Name) -->
                      <div class="d-flex flex-column text-start">
                        <span class="text-muted">Hello</span>
                        <span class="fw-medium text-dark pb-1">
                          {{
                            ((userDetails?.first_name + ' ' + userDetails?.last_name)?.length > 7)
                              ? (userDetails?.first_name + ' ' + userDetails?.last_name)?.slice(0, 7) + '...'
                              : (userDetails?.first_name + ' ' + userDetails?.last_name)
                          }}
                        </span>
                      </div>
                  
                      <!-- Dropdown Icon -->
                      <img src="assets/img/chevron-down.png" alt="icon" class="ms-auto" style="width: 12px; height: 12px; margin-left: auto;">
                    </button>

                    <!-- Custom Dropdown Menu -->
                    <div class="custom-dropdown" *ngIf="isDropdownOpen">

                      <!-- <button (click)="onMyProfile()" class="custom-menu-button profile-button">
                        <div class="d-flex align-items-center">
                          <img class="me-2 icon" src="assets/img/edit-profile-icon.svg" alt="logo">
                          <span class="label">My Profile</span>
                        </div>
                      </button> -->

                      <!-- <button (click)="onPurchaseHistory()" class="custom-menu-button purchase-button">
                        <div class="d-flex align-items-center">
                          <img class="me-2 icon" src="assets/img/purchase-history-logo.svg" alt="logo">
                          <span class="label">Purchase History</span>
                        </div>
                      </button> -->

                      <button (click)="logout()" class="custom-menu-button logout-button">
                        <div class="d-flex align-items-center">
                          <i class="fa fa-sign-out me-2 icon"></i>
                          <span class="label">Logout</span>
                        </div>
                      </button>
                    </div>
                  </div>
                  


                </div>

                <div *ngIf="userDetails?.type == 'institute'">
                  <div class="d-flex flex-row">
                  <!-- BUTTON - 1 (HELP BUTTON) -->
                  <button [matMenuTriggerFor]="helpMenu" #createPlanmenuTrigger="matMenuTrigger" (mouseenter)="targetMenuTrigger = createPlanmenuTrigger;
                                mouseEnter(createPlanmenuTrigger)" (mouseleave)="mouseLeave(createPlanmenuTrigger)"
                    class="btn btn-help rounded-pill me-4">
                    Support
                    <img class="img-fluid" src="assets/img/question-mark-circle.svg" alt="icon">
                  </button>
                  <!-- HELP POPUP -->
                  <mat-menu #helpMenu="matMenu" [hasBackdrop]="false" [overlapTrigger]="false">
                    <div (mouseenter)="mouseEnter(targetMenuTrigger)" (mouseleave)="mouseLeave(targetMenuTrigger)"
                      class="popup-content px-3 py-2">
                      <p class="fw-bold">Need Assistance?</p>
                      <hr>
                      <div class="d-flex align-items-center">
                        <img src="assets/img/phone-call.png" alt="Phone" class="me-2">
                        <a href="tel:+918422887258">+91 {{AppConfig.contacts.contact1.contact}}</a>
                      </div>
                      <hr>
                      <div class="d-flex align-items-center mt-2">
                        <img src="assets/img/mail.png" alt="Email" class="me-2">
                        <a href="mailto:contact@iited.com" class="text-decoration-underline">{{AppConfig.emails.email1}}</a>
                      </div>
                    </div>
                  </mat-menu>
                  <!-- BUTTON - (User Profile) -->
                  <div class="position-relative">
                    <button (click)="toggleDropdown()" class="btn-user d-flex align-items-center border border-1 rounded-pill px-3 py-2" type="button" style="min-width: 150px;">
                      
                      <!-- User Icon -->
                      <i class="fa fa-user me-2" style="color: #2A65C0; font-size: 1.2rem;" aria-hidden="true"></i>
                  
                      <!-- Text (Hello + Name) -->
                      <div class="d-flex flex-column text-start">
                        <!-- <span class="text-muted">Hello</span> -->
                        <span class="fw-medium text-dark">
                          {{
                            (userDetails?.name.length > 7)
                              ? userDetails?.name?.slice(0, 7) + '...'
                              : userDetails?.name
                          }}
                        </span>
                      </div>
                  
                      <!-- Dropdown Icon -->
                      <!-- <img src="assets/img/chevron-down.png" alt="icon" class="ms-auto" style="width: 12px; height: 12px; margin-left: auto;"> -->
                      <img src="assets/img/chevron-down.png" alt="icon" class="ms-auto">
                    </button>

                    <!-- Custom Dropdown Menu -->
                    <div class="custom-dropdown" *ngIf="isDropdownOpen">
                      <button (click)="onPurchaseHistory()" class="custom-menu-button purchase-button">
                        <div class="d-flex align-items-center">
                          <img class="me-2 icon" src="assets/img/purchase-history-logo.svg" alt="logo">
                          <span class="label">Payment History</span>
                        </div>
                      </button>

                      <button (click)="logout()" class="custom-menu-button logout-button">
                        <div class="d-flex align-items-center">
                          <i class="fa fa-sign-out me-2 icon"></i>
                          <span class="label">Logout</span>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

                <!-------School My account------>
                <!-- <div class="d-flex align-items-center gap_10"> -->
                  <!-- <a *ngIf="this.userDetails.type == 'school'" routerLink="/school/dashboard">
                    <p class="my_account_text school_hdr_btn">Go To Dashboard</p>
                  </a> -->
                  <!-- <a *ngIf="this.userDetails.type == 'school'" routerLink="/school/dashboard">
                    <p class="my_account_text btn_theme">School Dashboard</p>
                  </a> -->
                  <!-- <a *ngIf="this.userDetails.type == 'school'" routerLink="/school/school-profile">
                    <p class="my_account_text school_hdr_btn">My School Profile</p>
                  </a> -->
                  <!-- <a>
                    <p class="my_account_text school_hdr_btn">Logout</p>
                  </a> -->
                <!-- </div> -->
              </li>
            </ul>
            </div>
          </div>        
        </div>      
    </nav>
  </div>
</header>